import React, { useEffect, useState } from "react";
import { Pagination, PaginationItem, PaginationLink, Badge } from "reactstrap";

import { Button, Table } from "reactstrap";

import { getBlogsBySlug } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Col, Container, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import useToastr from "helpers/toastr";
import { FaCaretDown, FaCaretUp } from "react-icons/fa";
import ButtonLoader from "Component/Common/ButtonLoader";
import { useTranslation } from 'react-i18next';

const ViewBlogs = () => {
    const itemsPerPage = 1;
    const navigate = useNavigate();
    const toastr = useToastr();
    const lang = localStorage.getItem("lang")

    let urlPath = window.location.pathname.split("/");
    let path = urlPath[2];

    const [selectedItem, setSelectedItem] = useState();
    const { t } = useTranslation();

    const {  blogDetails, loading } = useSelector(({ Blogs }) => Blogs);
    const dispatch = useDispatch();
    const [contentInfo, setContentInfo] = useState();

    const [blogInfo, setBlogInfo] = useState();

    const getContentFnc = () => {
        const callBack = (response) => {
            if (response.status == "success") {
                setContentInfo(response?.data)
            }
        }
        dispatch(getBlogsBySlug({ data: path }, callBack))
    }

    /**
        * Used for calling the privacy-policy and terms-conditions api
        */
    useEffect(() => {
        if(path){
            getContentFnc();

        }


    }, [path ,lang])


    const handleBack = () => {
        navigate(-1);
    };


    return (
        <React.Fragment>

            <section className="history_page home_banner_main sellpagetwo position-relative">
                <div className="top_circle"></div>
                <Container>
                    <div className="d-flex align-items-center">
                        <Link to="" onClick={handleBack} className="arrow_back me-3">
                            <svg
                                role="button"
                                width="25"
                                height="25"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 14 10"
                            >
                                <path
                                    stroke="#000"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="1"
                                    d="M13 5H1m0 0 4 4M1 5l4-4"
                                />
                            </svg>
                        </Link>

                        <h4 className="text-start m-0">{lang == "ar" ? contentInfo?.titleAr : contentInfo?.titleEn}</h4>
                    </div>

                    <div className="history_table mt-4">
                        {loading && <ButtonLoader />}
                        <div className="blogWrpper">
                            <Row className="justify-content-center">
                                <Col lg="10">
                                    <div className="MainBlogImg">
                                        <img src={contentInfo?.blogImage?.link} alt="" className="img-fluid w-100" />
                                    </div>
                                    <div className="content py-3 text-start">
                                        <h2 className="m-0 fw-bold py-2">{lang == "ar" ? contentInfo?.titleAr : contentInfo?.titleEn}</h2>
                                        <p className="m-0 py-2"> {lang == "ar" ? contentInfo?.descriptionAr : contentInfo?.descriptionEn}
                                        </p>
                                    </div>
                                </Col>
                            </Row>

                        </div>
                    </div>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default ViewBlogs;
